/* eslint-disable import/prefer-default-export */
import { getSystemLocale } from '@/utils/intl';

let browserLocaleOptions = { // Default locale
  hour: 'numeric',
  hour12: false,
  locale: 'en-US',
};
if (window.Intl && typeof window.Intl === 'object') {
  browserLocaleOptions = new Intl.DateTimeFormat(getSystemLocale(), { hour: 'numeric' }).resolvedOptions();
}

// TODO: Remove
export const browserResolvedLocaleOptions = browserLocaleOptions;

// Note: Statuses order [0, 4, 5, 1, 2, 3]
// TODO: Investigate option to replace classes with CSS var()
export const guestStatus = {
  0: {
    name: 'No status',
    tagClasses: 'text-status-none bg-status-none-15',
    navigationClasses: 'status-none',
    order: 0,
    importOption: true,
    isVisible: () => true,
  },
  1: {
    name: 'Attending',
    tagClasses: 'text-status-attending bg-status-attending-15',
    navigationClasses: 'status-attending',
    order: 3,
    importOption: true,
    isVisible: () => true,
  },
  2: {
    name: 'Checked-in',
    tagClasses: 'text-status-checked-in bg-status-checked-in-15',
    navigationClasses: 'status-checked-in',
    order: 4,
  },
  3: {
    name: 'Checked-out',
    tagClasses: 'text-status-checked-out bg-status-checked-out-15',
    navigationClasses: 'status-checked-out',
    isVisible: (event) => Boolean(event?.isSupportingCheckOut),
    order: 5,
  },
  4: {
    name: 'Invited',
    tagClasses: 'text-status-invited bg-status-invited-15',
    navigationClasses: 'status-invited',
    order: 1,
    importOption: true,
    isVisible: (event) => Boolean(event?.isSupportingRSVP),
  },
  5: {
    name: 'Declined',
    tagClasses: 'text-status-declined bg-status-declined-15',
    navigationClasses: 'status-declined',
    order: 2,
    isVisible: (event) => Boolean(event?.isSupportingRSVP),
  },
  default: {
    name: 'Unknown',
    tagClasses: 'text-status-unknown bg-status-unknown-15',
    isVisible: () => false,
  },
};

export function getGuestFilterTitle(filter) {
  if (filter.property === 'status') {
    return guestStatus[filter.value].name;
  } if (filter.property === 'vip') {
    return 'VIPs';
  }
  return filter.property;
}

export function applyFilterConditions(filterConditions, filter, guest) {
  const conditionResults = [];
  const filterConditionsTotal = filter.conditions.length;
  let mainGuestCount = 0;
  let extraGuestCount = 0;
  let mainGuest = 0;
  let extraGuest = 0;

  filter.conditions.forEach((filterCondition, filterConditionIndex) => {
    const conditionResult = filterConditions[filterCondition].condition(guest);

    if (conditionResult.mainGuestCount || conditionResult.extraGuestCount) { // Filter condition applies
      conditionResults.push(conditionResult);
      conditionResults[filterConditionIndex] = true;
      mainGuestCount = mainGuestCount || conditionResult.mainGuestCount;
      extraGuestCount += conditionResult.extraGuestCount;
    } else {
      conditionResults[filterConditionIndex] = false;
    }
  });

  if ((filterConditionsTotal === 1 && conditionResults[0])
    || (filterConditionsTotal > 1 && conditionResults.every((f) => f))) { // Filter conditions all apply
    mainGuest += mainGuestCount;
    extraGuest += extraGuestCount;
  }

  return {
    mainGuest,
    extraGuest,
  };
}

export function applyGuestFilters(availableFilters, filterConditions, { newGuestData, oldGuestData }) {
  const filterCountModifiers = [];

  availableFilters.forEach((filter, filterIndex) => {
    if (newGuestData) {
      const filterConditionResultNew = applyFilterConditions(filterConditions, filter, newGuestData);

      if (filterConditionResultNew.mainGuest || filterConditionResultNew.extraGuest) {
        filterCountModifiers[filterIndex] = {
          mainGuest: filterConditionResultNew.mainGuest,
          extraGuest: filterConditionResultNew.extraGuest,
        };
      }
    }

    if (oldGuestData) {
      const filterConditionResultOld = applyFilterConditions(filterConditions, filter, oldGuestData);

      if (filterConditionResultOld && (filterConditionResultOld.mainGuest || filterConditionResultOld.extraGuest)) {
        if (newGuestData && filterCountModifiers[filterIndex]) {
          filterCountModifiers[filterIndex].mainGuest -= filterConditionResultOld.mainGuest;
          filterCountModifiers[filterIndex].extraGuest -= filterConditionResultOld.extraGuest;
        } else {
          filterCountModifiers[filterIndex] = {
            mainGuest: -filterConditionResultOld.mainGuest,
            extraGuest: -filterConditionResultOld.extraGuest,
          };
        }
      }
    }
  });

  return filterCountModifiers;
}

export const guestProperties = {
  firstName: {
    label: 'First name',
    isImportOption: true,
    isExportOption: true,
    importColumnMatching: ['first'],
  },
  lastName: {
    label: 'Last name',
    isImportOption: true,
    isExportOption: true,
    importColumnMatching: ['last', 'surname'],
  },
  email: {
    label: 'Email',
    isImportOption: true,
    isExportOption: true,
    importColumnMatching: ['email', '@'],
  },
  status: {
    label: 'Guest status',
    isImportOption: true,
    isExportOption: true,
    importColumnMatching: ['status'],
  },
  vip: {
    label: 'VIP',
    isImportOption: true,
    isExportOption: true,
    importColumnMatching: ['vip'],
  },
  notes: {
    label: 'Note',
    isImportOption: true,
    isExportOption: true,
    importColumnMatching: ['note', 'desc'],
  },
  phone: {
    label: 'Phone number',
    isImportOption: true,
    isExportOption: true,
    importColumnMatching: ['phone'],
  },
  company: {
    label: 'Organization',
    isImportOption: true,
    isExportOption: true,
    importColumnMatching: ['company', 'organization', 'organisation', 'business', 'corporation', 'firm', 'agency', 'office'],
  },
  checkedInExtraGuests: {
    label: 'Checked-in extra\'s',
    isExportOption: true,
    importColumnMatching: ['checked'],
  },
  totalExtraGuests: {
    label: 'Total extra\'s',
    isImportOption: true,
    isExportOption: true,
    importColumnMatching: ['total extra'],
  },
  checkInTime: {
    label: 'Check-in time',
    isExportOption: true,
  },
  checkOutTime: {
    label: 'Check-out time',
    isExportOption: true,
  },
  barcodeValue: {
    label: 'Barcode value',
    isImportOption: true,
    isExportOption: true,
    importColumnMatching: ['barcode value', 'barcode', 'qr code', 'qr-code'],
  },
};

// TEST GUESTS FOR GUEST FILTERING
// const testGuests = [{
//   status: 0,
// }, {
//   status: 0,
//   totalExtraGuests: 3,
// }, {
//   status: 0,
//   checkedInExtraGuests: 1,
//   totalExtraGuests: 3,
// }, {
//   status: 0,
//   checkedInExtraGuests: 3,
//   totalExtraGuests: 3,
// }, {
//   status: 1,
// }, {
//   status: 1,
//   totalExtraGuests: 3,
// }, {
//   status: 1,
//   checkedInExtraGuests: 1,
//   totalExtraGuests: 3,
// }, {
//   status: 1,
//   checkedInExtraGuests: 3,
//   totalExtraGuests: 3,
// }, {
//   status: 2,
// }, {
//   status: 2,
//   totalExtraGuests: 3,
// }, {
//   status: 2,
//   checkedInExtraGuests: 1,
//   totalExtraGuests: 3,
// }, {
//   status: 2,
//   checkedInExtraGuests: 3,
//   totalExtraGuests: 3,
// }];
// testGuests.forEach((guest, guestIndex) => {
//   console.log(`# Guest ${guestIndex + 1} | Status: ${guest.status}, CheckedInExtra's: ${guest.checkedInExtraGuests}, TotalExtra's: ${guest.totalExtraGuests}`);
//
//   advancedFilters.forEach((filter) => {
//     const filterResult = filter.conditions(guest);
//     console.log(`# ${filter.meta.name} | MainGuestCount: ${filterResult.mainGuestCount}, ExtraGuestCount: ${filterResult.extraGuestCount}`);
//   });
//   console.log('-----------------------------------------------------------------------------');
// });
